import { openDB } from "idb";
// Indexed DB Structure
// Change version after add more Items
export const dbPromise = openDB("cashier-db", 12, {
    upgrade(db) {
        if (!db.objectStoreNames.contains("orders")) {
            db.createObjectStore("orders");
        }
        if (!db.objectStoreNames.contains("sync_orders")) {
            db.createObjectStore("sync_orders");
        }
        if (!db.objectStoreNames.contains("categories")) {
            db.createObjectStore("categories");
        }
        if (!db.objectStoreNames.contains("sync_categories")) {
            db.createObjectStore("sync_categories");
        }
        if (!db.objectStoreNames.contains("discounts")) {
            db.createObjectStore("discounts");
        }
        if (!db.objectStoreNames.contains("sync_discounts")) {
            db.createObjectStore("sync_discounts");
        }
        if (!db.objectStoreNames.contains("extras")) {
            db.createObjectStore("extras");
        }
        if (!db.objectStoreNames.contains("sync_extras")) {
            db.createObjectStore("sync_extras");
        }
        if (!db.objectStoreNames.contains("products")) {
            db.createObjectStore("products");
        }
        if (!db.objectStoreNames.contains("sync_products")) {
            db.createObjectStore("sync_products");
        }
        if (!db.objectStoreNames.contains("offers")) {
            db.createObjectStore("offers");
        }
        if (!db.objectStoreNames.contains("sync_offers")) {
            db.createObjectStore("sync_offers");
        }
        if (!db.objectStoreNames.contains("historic_data")) {
            db.createObjectStore("historic_data");
        }
        if (!db.objectStoreNames.contains("register_entries")) {
            db.createObjectStore("register_entries");
        }
        if (!db.objectStoreNames.contains("sync_register_entries")) {
            db.createObjectStore("sync_register_entries");
        }
        if (!db.objectStoreNames.contains("workspace_user")) {
            db.createObjectStore("workspace_user");
        }
        if (!db.objectStoreNames.contains("workspace")) {
            db.createObjectStore("workspace");
        }
        if (!db.objectStoreNames.contains("sync_timestamp")) {
            db.createObjectStore("sync_timestamp");
        }
        if (!db.objectStoreNames.contains("rapport_meta")) {
            db.createObjectStore("rapport_meta");
        }
        if (!db.objectStoreNames.contains("time_tracking")) {
            db.createObjectStore("time_tracking");
        }
        if (!db.objectStoreNames.contains("sync_time_tracking")) {
            db.createObjectStore("sync_time_tracking");
        }
    },
});